import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f8445f36"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "record" }
const _hoisted_2 = { class: "thead" }
const _hoisted_3 = {
  key: 0,
  class: "hint"
}
const _hoisted_4 = {
  key: 1,
  class: "tbody"
}

import { useGame } from '@/store';
import { storeToRefs } from 'pinia';
import RecordItem from '@/versions/basic/components/RecordItem.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Record',
  setup(__props) {

const gameStore = useGame();
const { games } = storeToRefs(gameStore);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (_, index) => {
        return _createElementVNode("li", {
          key: `th${index}`
        }, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t(`RESULT__TABLE_HEAD__${index + 1}`)), 1)
        ])
      }), 64))
    ]),
    (_unref(games)?.length === 0)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.$t('RESULT__NO_RECORD')), 1))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(games), (game, index) => {
            return (_openBlock(), _createBlock(RecordItem, {
              key: `game${index}`,
              game: game
            }, null, 8, ["game"]))
          }), 128))
        ]))
  ]))
}
}

})